<ng-container *ngIf="viewModel$ | async as viewModel">
  <ng-container *ngIf="!renderHeadless; else headlessCustomerForm">
    <p-card>
      <div
        class="header-container"
        (click)="store.dispatch(actions.headerClicked())"
      >
        <div class="header-with-icon">
          <i class="pi pi-user p-mr-1"></i>
          <h2>Customer details</h2>
        </div>
        <div class="collapse-container">
          <i *ngIf="viewModel.isCardCollapsed" class="pi pi-chevron-down p-mr-2"></i>
          <i *ngIf="!viewModel.isCardCollapsed" class="pi pi-chevron-up p-mr-2"></i>
        </div>
      </div>
      <div class="main-content" *ngIf="!viewModel.isCardCollapsed">
        <ng-container *ngTemplateOutlet="customerFormTemplate"></ng-container>
      </div>
    </p-card>
  </ng-container>

  <ng-template #headlessCustomerForm>
    <div class="headless">
      <ng-container *ngTemplateOutlet="customerFormTemplate"></ng-container>
    </div>
  </ng-template>

  <ng-template #customerFormTemplate>
    <div class="one-column-container">
      <div class="edit-deselect-buttons">
        <p-messages
          severity="warn"
          styleClass="existing-customer-warning"
          *ngIf="viewModel.selectedCustomer && viewModel.isCustomerModified"
        >
          <ng-template pTemplate>
          You are editing an existing customer
          <button
            pButton
            class="p-button-text deselect-btn discard-button"
            label="Clear Customer"
            icon="pi pi-times"
            (click)="$event.stopPropagation(); store.dispatch(actions.clearCustomerButtonClicked())"
          ></button>
          </ng-template>
        </p-messages>

        <p-message
          *ngIf="!viewModel.customerEditable?.customerEditable"
          severity="warn"
          [text]="viewModel.customerEditable?.notEditableWarning"
          styleClass="existing-customer-warning"
        ></p-message>

          <button
            pButton
            *ngIf="viewModel.selectedCustomer && !viewModel.isCustomerModified"
            class="p-button-text deselect-btn discard-button"
            label="Clear Customer"
            icon="pi pi-times"
            (click)="$event.stopPropagation(); store.dispatch(actions.clearCustomerButtonClicked())"
          ></button>
      </div>
      <app-job-search-users
        #fullNameInput
        label="Full Name (Required)"
        placeholder="Customer Name"
        field="fullName"
        [tabIndex]="jobCreateIndexes['fullName']"
      >
      </app-job-search-users>
    </div>
    <div class="two-columns-container">
      <div class="input-area">
        <app-job-search-users
          #emailInput
          label="Email"
          placeholder="john@mail.com"
          field="email"
        ></app-job-search-users>
      </div>
      <div class="input-area">
        <app-job-search-users
          #phoneInput
          label="Phone"
          placeholder="(xxx)-xxx-xxxx"
          field="phone"
        ></app-job-search-users>
      </div>
    </div>
    <div *ngIf="viewModel.additionalContacts.length">
      <label>Additional Contacts</label>
      <div
        *ngFor="let contact of viewModel.additionalContacts; let i = index; trackBy: trackByIndex"
        class="input-row"
      >
        <div class="input-area">
          <input
            type="text"
            pInputText
            [ngModel]="contact.name"
            placeholder="Name"
            (blur)="store.dispatch(actions.additionalContactFieldChanged({ index: i, field: 'name', value: $any($event.target).value }))"
          />
          <div>
            <input
              type="text"
              pInputText
              [ngModel]="contact.email"
              placeholder="Email"
              [pattern]="viewModel.emailPattern"
              #additionalEmailModel="ngModel"
              (blur)="store.dispatch(actions.additionalContactFieldChanged({ index: i, field: 'email', value: $any($event.target).value }))"
            />
            <app-validation-messages
              [control]="additionalEmailModel.control"
              [requireTouched]="true"
            ></app-validation-messages>
          </div>
          <div>
            <input
              type="text"
              pInputText
              [ngModel]="contact.phone"
              placeholder="Phone"
              [pattern]="viewModel.phonePattern"
              #additionalPhoneModel="ngModel"
              (blur)="store.dispatch(actions.additionalContactFieldChanged({ index: i, field: 'phone', value: $any($event.target).value }))"
            />
            <app-validation-messages
              [control]="additionalPhoneModel.control"
              [requireTouched]="true"
            ></app-validation-messages>
          </div>
          <input
            type="text"
            pInputText
            [ngModel]="contact.relationship"
            placeholder="Relationship"
            (blur)="store.dispatch(actions.additionalContactFieldChanged({ index: i, field: 'relationship', value: $any($event.target).value }))"
          />
        </div>
        <button
          pButton
          class="editButton"
          icon="pi pi-times"
          [text]="true"
          (click)="store.dispatch(actions.removeAdditionalContactButtonClicked({ index: i }))"
        ></button>
      </div>
    </div>
    <button
      pButton
      class="editButton"
      icon="pi pi-plus"
      [text]="true"
      label="Add Contact"
      style="margin-top: 0.5rem; margin-bottom: 1rem;"
      (click)="store.dispatch(actions.addAdditionalContactButtonClicked())"
    ></button>
    <div class="two-columns-container date-company-container" style="margin-bottom: 0">
      <div>
        <label for="timeline" class="label-hack">Moving Date</label>
        <p-calendar
          #movingDateInput
          [tabindex]="jobCreateIndexes['movingDate']"
          [ngModel]="viewModel.movingDate"
          [iconDisplay]="'input'"
          [showIcon]="true"
          inputId="timeline"
          [style]="{ width: '100%', margin: '0.5rem 0 1.5rem 0' }"
          [inputStyle]="{ width: '100%' }"
          (ngModelChange)="this.store.dispatch(actions.movingDateSelected({ movingDate: $event }))"
        >
          ></p-calendar
        >
      </div>
      <div>
        <app-job-search-users
          #companyInput
          label="Company"
          placeholder="Company name"
          field="company"
          [tabIndex]="jobCreateIndexes['company']"
        ></app-job-search-users>
      </div>
    </div>
    <h5>Billing Address</h5>
    <app-job-location
      locationType="billing"
    ></app-job-location>
    <p-divider />
    <div class="two-columns-container">
      <div>
        <label for="JobTypeDropdown">Job Type</label>
        <p-dropdown
          #jobTypeInput
          [tabindex]="jobCreateIndexes['jobType']"
          [options]="jobCategories"
          [style]="{ width: '100%', marginTop: '0.5rem' }"
          [disabled]="true"
          id="JobTypeDropdown"
        ></p-dropdown>
      </div>
      <div>
        <label for="customerTypeDropdown">Customer Type</label>
        <p-dropdown
          #customerTypeInput
          [tabindex]="jobCreateIndexes['customerType']"
          [ngModel]="viewModel.customerType"
          [options]="viewModel.customerTypeOptions"
          [style]="{ width: '100%', marginTop: '0.5rem' }"
          (onChange)="store.dispatch(actions.customerTypeSelected({ customerType: $event.value }))"
          id="customerTypeDropdown"
        ></p-dropdown>
      </div>
    </div>
    <div class="two-columns-container">
      <div>
        <label for="howHeardDropdown"
          >Referral Source {{ viewModel.howHeardMandatory ? '(Required)' : '' }}</label
        >
        <app-source-tree-select
          [tabindex]="jobCreateIndexes['referralSource']"
          [ngModel]="viewModel.referralSource"
          [options]="viewModel.howHeardDropdownOptions"
          [style]="{ width: '100%', marginTop: '0.5rem' }"
          [required]="viewModel.howHeardMandatory"
          (valueChange)="store.dispatch(actions.referralSourceSelected({ referralSource: $event }))"
          id="howHeardDropdown"
        ></app-source-tree-select>
        <small class="field-error-message" *ngIf="viewModel.howHeardMandatory && !viewModel.referralSource">
          Referral source is required.
        </small>
      </div>
      <div>
        <label for="jobOriginDropdown">Job Origin</label>
        <p-dropdown
          #jobOriginInput
          [tabindex]="jobCreateIndexes['joOrigin']"
          [ngModel]="viewModel.jobOrigin"
          [options]="viewModel.jobOriginOptions"
          [style]="{ width: '100%', marginTop: '0.5rem' }"
          (onChange)="store.dispatch(actions.jobOriginSelected({ jobOrigin: $event.value }))"
          id="jobOriginDropdown"
        ></p-dropdown>
      </div>
    </div>
  </ng-template>
</ng-container>

<ng-template #empty>
  <div></div>
</ng-template>
